import * as i0 from '@angular/core';
import { input, computed, Component, ChangeDetectionStrategy, signal, output, Inject, NgModule, Injectable } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@digipay/ngx-spinner';
import { NgxSpinnerModule } from '@digipay/ngx-spinner';
import * as i3 from '@digipay/ngx-button';
import { NgxButtonComponent } from '@digipay/ngx-button';
import * as i4 from '@digipay/ngx-count-down';
import { NgxCountDownComponent } from '@digipay/ngx-count-down';
import * as i1 from '@digipay/ngx-skeleton-loading';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import * as i6 from '@digipay/ngx-bottom-sheet';
const _c0 = ["*"];
function StatusContentComponent_Conditional_0_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.statusIconClass());
  }
}
function StatusContentComponent_Conditional_0_DeferPlaceholder_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lib-ngx-skeleton-loading", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r0.iconState().size === "large" ? "96px" : "80px")("height", ctx_r0.iconState().size === "large" ? "96px" : "80px");
  }
}
function StatusContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, StatusContentComponent_Conditional_0_Defer_0_Template, 1, 2)(1, StatusContentComponent_Conditional_0_DeferPlaceholder_1_Template, 1, 2);
    i0.ɵɵdefer(2, 0, null, null, 1, null, null, 0, i0.ɵɵdeferEnableTimerScheduling);
    i0.ɵɵdeferOnIdle();
  }
}
function StatusContentComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c1 = [[["", "status-image", ""]], [["", "html-content", ""]]];
const _c2 = ["[status-image]", "[html-content]"];
const _c3 = a0 => ({
  "w-100": a0
});
const _c4 = () => ({
  name: "close"
});
const _c5 = a0 => ({
  hide: a0
});
function NgxStatusResultComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "ngx-button", 12);
    i0.ɵɵlistener("clickHandler", function NgxStatusResultComponent_Conditional_1_Template_ngx_button_clickHandler_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵstyleMap("tinted-on-back");
    i0.ɵɵproperty("mode", "icon-only")("size", "small")("leftIcon", i0.ɵɵpureFunction0(5, _c4));
  }
}
function NgxStatusResultComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.imgContent());
  }
}
function NgxStatusResultComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function NgxStatusResultComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.descriptionClass());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.description(), " ");
  }
}
function NgxStatusResultComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subDescription(), " ");
  }
}
function NgxStatusResultComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.warning(), " ");
  }
}
function NgxStatusResultComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.htmlContent());
  }
}
function NgxStatusResultComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function NgxStatusResultComponent_For_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "ngx-button", 13);
    i0.ɵɵlistener("clickHandler", function NgxStatusResultComponent_For_18_Template_ngx_button_clickHandler_1_listener() {
      const button_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick(button_r4.id));
    })("finished", function NgxStatusResultComponent_For_18_Template_ngx_button_finished_1_listener() {
      const button_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick(button_r4.id));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_12_0;
    const button_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(button_r4.style);
    i0.ɵɵproperty("mode", button_r4.mode)("size", (tmp_12_0 = button_r4.size) !== null && tmp_12_0 !== undefined ? tmp_12_0 : "large")("destructive", button_r4.destructive)("timer", button_r4.timer)("disabled", button_r4.disabled)("rightIcon", button_r4.rightIcon)("leftIcon", button_r4.leftIcon)("fullWidth", button_r4.fullWidth);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", button_r4.label, " ");
  }
}
function NgxStatusResultComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-spinner", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("size", "lg")("color", "primary");
  }
}
function NgxStatusResultComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-count-down", 14);
    i0.ɵɵlistener("finished", function NgxStatusResultComponent_Conditional_20_Template_ngx_count_down_finished_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFinish());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c5, ctx_r1.loading()))("timeInSeconds", ctx_r1.timer().timeInSeconds)("type", ctx_r1.timer().timerType);
  }
}
let StatusContentComponent = /*#__PURE__*/(() => {
  class StatusContentComponent {
    constructor() {
      this.iconState = input(null);
      this.statusIconClass = computed(() => {
        const classArr = ['status-icon', `status-icon-${this.iconState().state}`, `status-icon-${this.iconState().size}`];
        return classArr.join(' ');
      });
    }
    static {
      this.ɵfac = function StatusContentComponent_Factory(t) {
        return new (t || StatusContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StatusContentComponent,
        selectors: [["lib-status-content"]],
        inputs: {
          iconState: [i0.ɵɵInputFlags.SignalBased, "iconState"]
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [[1000], ["borderRadius", "50%", 3, "width", "height"]],
        template: function StatusContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, StatusContentComponent_Conditional_0_Template, 4, 0)(1, StatusContentComponent_Conditional_1_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, ctx.iconState() ? 0 : 1);
          }
        },
        dependencies: [i1.NgxSkeletonLoadingComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.status-icon[_ngcontent-%COMP%]{background-repeat:no-repeat;background-position:center;border-radius:50%}.status-icon-medium[_ngcontent-%COMP%]{width:80px;height:80px}.status-icon-large[_ngcontent-%COMP%]{width:96px;height:96px}.status-icon-error[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23F2F3F6\"/>%0D%0A<g clip-path=\"url(%23clip0_23982_6220)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.2404 55.2354C54.8716 55.6042 54.3865 55.7912 53.9015 55.7912C53.4139 55.7912 52.9314 55.6042 52.56 55.2354L47.9975 50.6703L43.4476 55.2202C42.7074 55.9604 41.5074 55.9604 40.7672 55.2202C40.0295 54.48 40.0295 53.2825 40.7672 52.5423L45.3171 47.9924L40.7646 43.4375C40.0244 42.6973 40.0244 41.4998 40.7646 40.7596C41.5048 40.0194 42.7023 40.0194 43.4425 40.7596L47.9949 45.312L52.5474 40.7621C53.2876 40.0219 54.4851 40.0219 55.2253 40.7621C55.9655 41.4998 55.9655 42.6998 55.2253 43.44L50.6754 47.9924L55.2404 52.5549C55.9806 53.2952 55.9806 54.4952 55.2404 55.2354ZM48 24C34.7672 24 24 34.7646 24 48C24 61.2328 34.7672 72 48 72C61.2328 72 72 61.2328 72 48C72 34.7646 61.2328 24 48 24Z\" fill=\"%23F9441F\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_23982_6220\">%0D%0A<rect width=\"48\" height=\"48\" fill=\"white\" transform=\"translate(24 24)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}.status-icon-warning[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23F2F3F6\"/>%0D%0A<g clip-path=\"url(%23clip0_23982_6228)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48 59.2901C46.9541 59.2901 46.1053 58.5019 46.1053 57.4535V57.3347C46.1053 56.2888 46.9541 55.44 48 55.44C49.0459 55.44 49.8947 56.2888 49.8947 57.3347C49.8947 58.3806 49.0459 59.2901 48 59.2901ZM46.0952 38.6728C46.0952 37.6269 46.944 36.7781 47.9899 36.7781C49.0358 36.7781 49.8846 37.6269 49.8846 38.6728V49.5335C49.8846 50.5794 49.0358 51.4282 47.9899 51.4282C46.944 51.4282 46.0952 50.5794 46.0952 49.5335V38.6728ZM48 24C34.7672 24 24 34.7672 24 48C24 61.2354 34.7672 72 48 72C61.2328 72 72 61.2354 72 48C72 34.7672 61.2328 24 48 24Z\" fill=\"%23FEC003\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_23982_6228\">%0D%0A<rect width=\"48\" height=\"48\" fill=\"white\" transform=\"translate(24 24)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}.status-icon-info[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23F2F3F6\"/>%0D%0A<g clip-path=\"url(%23clip0_23982_6226)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48 59.2901C46.9541 59.2901 46.1053 58.5019 46.1053 57.4535V57.3347C46.1053 56.2888 46.9541 55.44 48 55.44C49.0459 55.44 49.8947 56.2888 49.8947 57.3347C49.8947 58.3806 49.0459 59.2901 48 59.2901ZM46.0952 38.6728C46.0952 37.6269 46.944 36.7781 47.9899 36.7781C49.0358 36.7781 49.8846 37.6269 49.8846 38.6728V49.5335C49.8846 50.5794 49.0358 51.4282 47.9899 51.4282C46.944 51.4282 46.0952 50.5794 46.0952 49.5335V38.6728ZM48 24C34.7672 24 24 34.7672 24 48C24 61.2354 34.7672 72 48 72C61.2328 72 72 61.2354 72 48C72 34.7672 61.2328 24 48 24Z\" fill=\"%231159FC\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_23982_6226\">%0D%0A<rect width=\"48\" height=\"48\" fill=\"white\" transform=\"translate(24 24)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}.status-icon-done[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23F2F3F6\"/>%0D%0A<g clip-path=\"url(%23clip0_23982_6229)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.0876 43.5082L46.4211 55.1747C46.0497 55.5461 45.5672 55.7305 45.0821 55.7305C44.5945 55.7305 44.112 55.5461 43.7406 55.1747L37.9074 49.3415C37.1672 48.6013 37.1672 47.4013 37.9074 46.6611C38.6476 45.9208 39.8451 45.9208 40.5853 46.6611L45.0821 51.1554L55.4072 40.8278C56.1474 40.0876 57.3474 40.0876 58.0876 40.8278C58.8278 41.568 58.8278 42.768 58.0876 43.5082ZM48 24C34.7672 24 24 34.7672 24 48C24 61.2354 34.7672 72 48 72C61.2328 72 72 61.2354 72 48C72 34.7672 61.2328 24 48 24Z\" fill=\"%2300C958\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_23982_6229\">%0D%0A<rect width=\"48\" height=\"48\" fill=\"white\" transform=\"translate(24 24)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}.status-icon-empty[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 98 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A  <rect x=\"1\" y=\"1\" width=\"96\" height=\"96\" rx=\"48\" stroke=\"%23C9CBCF\" stroke-width=\"1.5\" stroke-linecap=\"round\"%0D%0A        stroke-dasharray=\"6 6\"/>%0D%0A  <path%0D%0A    d=\"M44.8652 64.9492C45.8732 66.2082 47.3852 67.0002 49.0586 67.0002C50.7496 67.0002 52.2616 66.2082 53.2696 64.9492\"%0D%0A    stroke=\"%2374777C\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A  <path%0D%0A    d=\"M34.3281 52.9946C34.764 58.2214 39.2669 59.5232 48.9984 59.5232C58.728 59.5232 63.2308 58.239 63.6686 52.9946C63.6686 47.7718 60.528 48.1066 60.528 41.6986C60.528 36.6937 55.9784 31 48.9984 31C42.0184 31 37.4688 36.6937 37.4688 41.7006C37.4688 48.1084 34.3281 47.7758 34.3281 52.9946Z\"%0D%0A    stroke=\"%2374777C\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A')}.status-icon-retry[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23101113\" fill-opacity=\"0.64\"/>%0D%0A<g clip-path=\"url(%23clip0_23982_6227)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.6948 52.4975C54.3108 52.8815 53.7621 53.101 53.2409 53.101C52.7197 53.101 52.1985 52.8815 51.787 52.4975L43.5024 44.2129C42.7069 43.4173 42.7069 42.1005 43.5024 41.305C44.3254 40.5094 45.6147 40.5094 46.4102 41.305L54.6948 49.5896C55.4904 50.3852 55.4904 51.7019 54.6948 52.4975ZM71.4012 37.9308C70.6057 37.1352 69.2889 37.1352 68.4934 37.9308L63.5555 42.8961L53.1038 32.4443L58.0416 27.5064C58.8646 26.7109 58.8646 25.3942 58.0416 24.5986C57.2461 23.8031 55.9567 23.8031 55.1338 24.5986L50.1959 29.5365L48.0013 27.3419C45.9165 25.257 42.268 25.257 40.1832 27.3419L35.602 31.9231C31.5968 35.9282 29.4571 41.4696 29.7314 47.1207C29.9234 51.5099 31.5145 55.5425 34.2303 58.8618L24.6015 68.4906C23.806 69.2861 23.806 70.6029 24.6015 71.3984C25.013 71.8099 25.5342 72.002 26.0555 72.002C26.5767 72.002 27.0979 71.8099 27.5094 71.3984L37.1382 61.7696C40.677 64.6775 45.066 66.104 49.5375 66.104C54.9692 66.104 60.4831 63.9917 64.6528 59.8219L68.658 55.8168C70.8251 53.6496 70.8251 50.1383 68.658 47.9986L66.4634 45.804L71.4012 40.8661C72.1967 40.0431 72.1967 38.7538 71.4012 37.9308Z\" fill=\"%23F2F3F6\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_23982_6227\">%0D%0A<rect width=\"49\" height=\"49\" fill=\"white\" transform=\"translate(23.5 23.5)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}.status-icon-waiting[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<circle cx=\"48\" cy=\"48\" r=\"48\" fill=\"%23F2F3F6\"/>%0D%0A<mask id=\"mask0_23985_26094\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"96\" height=\"96\">%0D%0A<path d=\"M96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48ZM19.2 48C19.2 63.9058 32.0942 76.8 48 76.8C63.9058 76.8 76.8 63.9058 76.8 48C76.8 32.0942 63.9058 19.2 48 19.2C32.0942 19.2 19.2 32.0942 19.2 48Z\" fill=\"%23D9D9D9\"/>%0D%0A</mask>%0D%0A<g mask=\"url(%23mask0_23985_26094)\">%0D%0A<circle cx=\"46.6006\" cy=\"90.7998\" r=\"5\" fill=\"%23000060\"/>%0D%0A</g>%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M62.086 46.25C61.286 44.86 60.53 43.548 60.53 40.448C60.53 34.798 55.496 28.75 48 28.75C40.5041 28.75 35.4701 34.798 35.4701 40.45C35.4701 43.55 34.7121 44.864 33.9121 46.252C33.1341 47.604 32.3301 49 32.3301 51.744C32.3301 51.77 32.3301 51.798 32.3341 51.826C32.8521 58.054 38.4701 59.272 48 59.272C57.528 59.272 63.148 58.054 63.67 51.744C63.67 48.998 62.866 47.6 62.086 46.25Z\" fill=\"%23000431\"/>%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.2706 62.1982H43.8667C43.2887 62.1982 42.7647 62.5302 42.5147 63.0482C42.2647 63.5702 42.3347 64.1862 42.6947 64.6362C44.0266 66.2962 45.9806 67.2482 48.0606 67.2482C50.1506 67.2482 52.1106 66.2962 53.4406 64.6362C53.8026 64.1862 53.8726 63.5682 53.6226 63.0482C53.3726 62.5302 52.8486 62.1982 52.2706 62.1982Z\" fill=\"%23000431\"/>%0D%0A</svg>%0D%0A')}.status-icon-question[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z\" fill=\"%23F2F3F6\"/>%0D%0A<g clip-path=\"url(%23clip0_24154_66646)\">%0D%0A<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M53.7566 50.6779L53.2817 50.944C51.0989 52.1634 50.3276 52.7899 50.3444 53.8611C50.3613 55.2556 49.2463 56.4008 47.8518 56.4211H47.8181C46.4371 56.4211 45.3086 55.3128 45.2918 53.9284C45.2345 49.6573 48.7276 47.7036 50.8126 46.5381L51.2876 46.2686C53.2042 45.2143 54.1608 43.7524 54.1608 41.9133C54.1608 38.8716 51.6851 36.3992 48.6434 36.3992C45.5478 36.3992 43.1225 38.8211 43.1225 41.9133C43.1225 43.3078 41.9907 44.4396 40.5962 44.4396C39.2017 44.4396 38.0699 43.3078 38.0699 41.9133C38.0699 36.0859 42.8126 31.3465 48.6434 31.3465C54.4707 31.3465 59.2135 36.0859 59.2135 41.9133C59.2135 45.6286 57.2733 48.7411 53.7566 50.6779ZM47.8215 64.7074C46.4269 64.7074 45.2952 63.6261 45.2952 62.2316V62.1305C45.2952 60.736 46.4269 59.6042 47.8215 59.6042C49.216 59.6042 50.3478 60.736 50.3478 62.1305C50.3478 63.5251 49.216 64.7074 47.8215 64.7074ZM48 16C30.3528 16 16 30.3562 16 48C16 65.6438 30.3528 80 48 80C65.6438 80 80 65.6438 80 48C80 30.3562 65.6438 16 48 16Z\" fill=\"black\"/>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_24154_66646\">%0D%0A<rect width=\"64\" height=\"64\" fill=\"white\" transform=\"translate(16 16)\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A')}"],
        changeDetection: 0
      });
    }
  }
  return StatusContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStatusResultComponent = /*#__PURE__*/(() => {
  class NgxStatusResultComponent {
    constructor(bottomSheet) {
      this.bottomSheet = bottomSheet;
      this.isBottomSheet = signal(!!this.bottomSheet.data());
      this.title = input(this.bottomSheet.data()?.title ?? '');
      this.description = input(this.bottomSheet.data()?.description ?? '');
      /**
       * @deprecated This input is deprecated and will be removed in future versions.
       */
      this.subDescription = input('');
      /**
       * @deprecated This input is deprecated and will be removed in future versions.
       */
      this.warning = input('');
      this.buttons = input(this.bottomSheet.data()?.buttons ?? []);
      this.loading = input(false);
      this.timer = input(null);
      /**
       * @deprecated This input is deprecated and will be removed in future versions.
       */
      this.state = input('DEFAULT');
      this.type = input(this.bottomSheet.data()?.type ?? 'Status');
      this.hasCloseIcon = input(false);
      this.htmlContent = signal(this.bottomSheet.data()?.htmlContent ?? null);
      this.imgContent = signal(this.bottomSheet.data()?.imgContent ?? null);
      this.iconState = input(this.bottomSheet.data()?.icon ?? null);
      this.iconStateComputed = computed(() => {
        if (typeof this.iconState() === 'string') {
          return {
            state: this.iconState(),
            size: 'large'
          };
        }
        return this.iconState();
      });
      this.clicked = output();
      this.finished = output();
      this.closed = output();
      // computed classes
      this.stateWrapperClass = computed(() => {
        return ['d-flex', 'align-items-center', 'flex-column', 'h-100', 'relative', this.isBottomSheet() ? 'gap-giant' : 'px-plus', this.type() === 'Status' || this.isBottomSheet() ? 'justify-content-space-between' : '', this.type() === 'Status' && !this.isBottomSheet() ? 'pb-plus' : '', this.type() !== 'Status' && !this.isBottomSheet() ? 'justify-content-center' : '', this.type() !== 'Status' && !this.isBottomSheet() ? 'gap-massive' : 'gap-huge', this.type() === 'Retry' ? 'surface-glass-high-contrast-invert' : ''].filter(Boolean).join(' ');
      });
      this.headerWrapperClass = computed(() => {
        return ['d-flex', 'flex-column', this.type() === 'Confirmation' ? ['text-align-start', 'gap-plus'] : '', this.type() !== 'Confirmation' ? 'text-align-center' : '', this.type() === 'Status' ? ['flex-grow', 'justify-content-center'] : '', this.type() !== 'Confirmation' && this.isBottomSheet() ? 'gap-low' : '', this.type() !== 'Confirmation' && !this.isBottomSheet() ? 'gap-micro' : '', this.type() === 'Confirmation' && this.isBottomSheet() ? 'w-100' : ''].filter(Boolean).flat(1).join(' ');
      });
      this.titleIconWrapperClass = computed(() => {
        return ['d-flex', 'align-items-center', this.type() === 'Confirmation' ? ['flex-row-reverse', 'justify-content-space-between', 'w-100', 'gap-low'] : '', this.type() !== 'Confirmation' ? ['flex-column', 'gap-huge'] : ''].filter(Boolean).flat(1).join(' ');
      });
      this.titleClass = computed(() => {
        return [this.state() === 'DONE' ? 'text-onback-success' : '', this.state() === 'FAILED' ? 'text-onback-error' : '', this.state() === 'PROGRESS' || this.state() === 'DEFAULT' ? 'text-onback-high' : '', this.type() === 'Retry' ? 'text-oninvert-high' : ''].filter(Boolean).join(' ');
      });
      this.descriptionClass = computed(() => {
        return ['b-2', this.type() === 'Retry' ? 'text-oninvert-medium' : '', this.type() !== 'Retry' ? 'text-onback-medium' : ''].filter(Boolean).join(' ');
      });
      this.buttonsWrapperClass = computed(() => {
        return ['d-flex', 'align-items-center', 'gap-minus', 'justify-content-center', 'flex-wrap'].filter(Boolean).join(' ');
      });
    }
    onClick(id) {
      if (this.isBottomSheet()) {
        this.bottomSheet.outputData.set({
          clicked: id
        });
        this.closeBottomSheet();
      } else {
        this.clicked.emit(id);
      }
    }
    onFinish() {
      if (this.isBottomSheet()) {
        this.bottomSheet.outputData.set({
          finished: true
        });
        this.closeBottomSheet();
      } else {
        this.finished.emit();
      }
    }
    onClose() {
      this.closed.emit();
    }
    closeBottomSheet() {
      this.bottomSheet.closeBottomSheet();
    }
    static {
      this.ɵfac = function NgxStatusResultComponent_Factory(t) {
        return new (t || NgxStatusResultComponent)(i0.ɵɵdirectiveInject('STATE_BOTTOM_SHEET'));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxStatusResultComponent,
        selectors: [["ngx-status-result"]],
        inputs: {
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          description: [i0.ɵɵInputFlags.SignalBased, "description"],
          subDescription: [i0.ɵɵInputFlags.SignalBased, "subDescription"],
          warning: [i0.ɵɵInputFlags.SignalBased, "warning"],
          buttons: [i0.ɵɵInputFlags.SignalBased, "buttons"],
          loading: [i0.ɵɵInputFlags.SignalBased, "loading"],
          timer: [i0.ɵɵInputFlags.SignalBased, "timer"],
          state: [i0.ɵɵInputFlags.SignalBased, "state"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          hasCloseIcon: [i0.ɵɵInputFlags.SignalBased, "hasCloseIcon"],
          iconState: [i0.ɵɵInputFlags.SignalBased, "iconState"]
        },
        outputs: {
          clicked: "clicked",
          finished: "finished",
          closed: "closed"
        },
        ngContentSelectors: _c2,
        decls: 21,
        vars: 23,
        consts: [[1, "close-icon", "mt-big", "mx-plus", "dark"], [1, "d-flex", "justify-content-center", "align-items-center", "flex-column", "text-align-center", 3, "ngClass"], [3, "iconState"], [3, "ngTemplateOutlet"], [1, "st-3"], [3, "class"], [1, "text-onback-error", "c-3", "text-align-center", "mt-medium", "p-medium", "border-t-100", "border-color-tint"], [1, "l-1", "text-align-center"], [1, "d-flex", "flex-column", "w-100", "gap-huge"], [1, "flex-button"], [3, "size", "color"], [3, "ngClass", "timeInSeconds", "type"], [3, "clickHandler", "mode", "size", "leftIcon"], [1, "no-wrap", 3, "clickHandler", "finished", "mode", "size", "destructive", "timer", "disabled", "rightIcon", "leftIcon", "fullWidth"], [3, "finished", "ngClass", "timeInSeconds", "type"]],
        template: function NgxStatusResultComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, NgxStatusResultComponent_Conditional_1_Template, 2, 6, "div", 0);
            i0.ɵɵelementStart(2, "div")(3, "div")(4, "div", 1)(5, "lib-status-content", 2);
            i0.ɵɵtemplate(6, NgxStatusResultComponent_Conditional_6_Template, 1, 1, "ng-container", 3)(7, NgxStatusResultComponent_Conditional_7_Template, 1, 0);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 4);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, NgxStatusResultComponent_Conditional_10_Template, 2, 3, "div", 5)(11, NgxStatusResultComponent_Conditional_11_Template, 2, 1, "div", 6)(12, NgxStatusResultComponent_Conditional_12_Template, 2, 1, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 8);
            i0.ɵɵtemplate(14, NgxStatusResultComponent_Conditional_14_Template, 1, 1, "ng-container", 3)(15, NgxStatusResultComponent_Conditional_15_Template, 1, 0);
            i0.ɵɵelementStart(16, "div");
            i0.ɵɵrepeaterCreate(17, NgxStatusResultComponent_For_18_Template, 3, 11, "div", 9, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵtemplate(19, NgxStatusResultComponent_Conditional_19_Template, 1, 2, "ngx-spinner", 10)(20, NgxStatusResultComponent_Conditional_20_Template, 1, 5, "ngx-count-down", 11);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.stateWrapperClass());
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.hasCloseIcon() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.headerWrapperClass());
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.titleIconWrapperClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c3, ctx.type() !== "Confirmation"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("iconState", ctx.iconStateComputed());
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, ctx.isBottomSheet() ? 6 : 7);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.titleClass());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.title(), " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, ctx.description() ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.subDescription() ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(12, ctx.warning() ? 12 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(14, ctx.isBottomSheet() ? 14 : 15);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.buttonsWrapperClass());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.buttons());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(19, ctx.loading() ? 19 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(20, ctx.timer() ? 20 : -1);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgTemplateOutlet, i2.NgxSpinnerComponent, i3.NgxButtonComponent, i4.NgxCountDownComponent, StatusContentComponent],
        styles: ["[_nghost-%COMP%]   *[_ngcontent-%COMP%]{direction:rtl}.flex-button[_ngcontent-%COMP%]{flex:1;max-width:100%;box-sizing:border-box;display:flex;justify-content:center}.no-wrap[_ngcontent-%COMP%]{white-space:nowrap}.close-icon[_ngcontent-%COMP%]{position:absolute;top:0;right:0}.relative[_ngcontent-%COMP%]{position:relative}"],
        changeDetection: 0
      });
    }
  }
  return NgxStatusResultComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStatusResultModule = /*#__PURE__*/(() => {
  class NgxStatusResultModule {
    static {
      this.ɵfac = function NgxStatusResultModule_Factory(t) {
        return new (t || NgxStatusResultModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxStatusResultModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, NgxSpinnerModule, NgxButtonComponent, NgxCountDownComponent, NgxSkeletonLoadingComponent]
      });
    }
  }
  return NgxStatusResultModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStateService = /*#__PURE__*/(() => {
  class NgxStateService {
    constructor(bottomSheet) {
      this.bottomSheet = bottomSheet;
    }
    openBottomSheet(data, config) {
      this.bottomSheet.openBottomSheet(NgxStatusResultComponent, {
        ...data
      }, config);
    }
    get outputData() {
      return this.bottomSheet.outputData.asReadonly();
    }
    closeBottomSheet() {
      this.bottomSheet.closeBottomSheet();
    }
    onClose() {
      return this.bottomSheet.onClose;
    }
    static {
      this.ɵfac = function NgxStateService_Factory(t) {
        return new (t || NgxStateService)(i0.ɵɵinject('STATE_BOTTOM_SHEET'));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxStateService,
        factory: NgxStateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxStateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-status-result
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxStateService, NgxStatusResultComponent, NgxStatusResultModule, StatusContentComponent };
